import type {
  BetterstartCommandRuntime,
  RemoveSchemaCommandOptions
} from '@cli-types/core-engine/commands.js'
import { Command } from 'commander'

export function createRemoveSchemaCommand(runtime: BetterstartCommandRuntime): Command {
  return new Command('remove-schema')
    .description('Remove generated files for a user-authored schema')
    .argument('<schema>', 'Schema name to remove (e.g. posts, categories, contact)')
    .option('-f, --force', 'Skip confirmation prompt', false)
    .option('--cwd <path>', 'Project root path')
    .action((schemaName: string, options: RemoveSchemaCommandOptions) =>
      runtime.runRemoveSchema(schemaName, options)
    )
}
